import { useState } from "react";
import API from "../services/api";
import { useNavigate, Link, useSearchParams } from "react-router-dom";
import "./Signup.css";

const Signup = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const source = searchParams.get("source") || "direct";

  const [formData, setFormData] = useState({
    display_name: "",
    email: "",
    password: "",
  });

  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSignup = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      const res = await API.post("/auth/signup", {
        ...formData,
        source,
      });
      if (res.data?.access_token) {
        localStorage.setItem("token", res.data.access_token);
      }
      navigate("/dashboard");
    } catch (err) {
      alert(err.response?.data?.detail || "Signup failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="signup-container">
      <div className="signup-grid">
        {/* LEFT SIDE */}
        <div className="signup-left">
          <h1 className="signup-title">
            🚀 Request Access <span className="highlight">— Limited MVP Testing</span>
          </h1>
          <p className="signup-subtitle">
            Join the Intel dashboard to explore:
          </p>
          <ul className="signup-features">
            <li><strong>Overview</strong> — Track market trends and creator performance.</li>
            <li><strong>Compare Creators</strong> — Benchmark creators side‑by‑side.</li>
            <li><strong>Agency Requests</strong> — Submit tailored research requests.</li>
            <li><strong>Agency Feedback</strong> — Influence future intelligence.</li>
            <li><strong>Views Ranking</strong> — Identify high‑impact creators by views.</li>
            <li><strong>Research Process</strong> — Transparent methodology behind every CY score.</li>
          </ul>
          <p className="signup-note">
            ⚡ Access is limited to select agencies during MVP testing.
          </p>
        </div>

        {/* RIGHT SIDE */}
        <div className="signup-card">
          <div className="signup-header">
            <h2>Create Your Account</h2>
            <p>Request access to the Intel dashboard</p>
          </div>

          <form onSubmit={handleSignup} className="signup-form">
            <div>
              <label>Display Name</label>
              <input
                type="text"
                name="display_name"
                value={formData.display_name}
                onChange={handleChange}
                placeholder="Enter your display name"
                required
              />
            </div>

            <div>
              <label>Email Address</label>
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                placeholder="Enter your email"
                required
              />
            </div>

            <div>
              <label>Password</label>
              <div className="password-wrapper">
                <input
                  type={showPassword ? "text" : "password"}
                  name="password"
                  value={formData.password}
                  onChange={handleChange}
                  placeholder="Enter password"
                  required
                />
                <span onClick={() => setShowPassword(!showPassword)} className="toggle-password">
                  {showPassword ? "🙈 Hide" : "👁️ Show"}
                </span>
              </div>
            </div>

            <button type="submit" disabled={loading} className="signup-btn-main">
              {loading ? "Signing up..." : "🚀 Request Access"}
            </button>
          </form>

          <div className="login-link">
            Already have an account?{" "}
            <Link to="/login" className="login-btn">Limited Login</Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Signup;
